import React, { useState } from "react";
import DatePicker from "react-datepicker";
import { Tooltip as ReactTooltip } from "react-tooltip";
import SelectCountry from "react-select";
import WorldContinents from "../../../Controls/WorldContinents/WorldContinents";
import MultipleIps from "../../../Controls/MultipleIps/MultipleIps";
import { AppContext } from "../../../../AppContext";
import Alert from "../../../Controls/Alerts/Alerts"

const ControlStatusModal = ({
  modalForControlStatus,
  selectedLanguage,
  securityLevelTextColor,
  handleLevelChange,
  constSecurityLevelText,
  isDatetimeControl,
  startTime,
  expiryTime,
  handlerExpirationDaysStartTime,
  handlerExpirationDaysExpiryTime,
  dateFormatValueOriginal,
  dateFormatValueLower,
  domains,
  setDomains,
  maxReadsText,
  ChangeMaxReadsTexts,
  maxViewsPerDocumentText,
  ChangeMaxViewsPerDocumentTexts,
  responseAddress,
  setResponseAddress,
  constAllowResFlag,
  sendVerificationCodeDisable,
  handleSelectionChange,
  selectedOptions,
  filteredOptions,
  MultiValueRemove,
  steganography,
  setSteganography,
  canPrint,
  setPrint,
  voting,
  handleSetVoting,
  voteSharing,
  setVoteSharing,
  distributionList,
  setDistributionList,
  isPageLevelRestrictionChecked,
  handlePageLevelRestrictionCheck,
  handlePageLevelRestrictionEdit,
  handlerModelCancelForControlStatus,
  handlerModelConfirmForControlStatus,
  IntiateTime,
  constSecurityLevelClass,
  components,
  isPageLevelRestrictionSetting,
  isPageLevelData,
  pageLevelResRef,
  constContinents,
  constmultipleips,
  setConstMultipleIps,
  eDisclosure,
  EDisclosureResRef,
  handleEDisclosure,
  isEDisclosureChecked,
  maxPrintsPerReader,
  maxPrintsPerDocument,
  currentDocument,
  onSaveRecipientPrintSettings,
  recipientPrintData,
  setRecipientPrintData
}) => {
  const [maxPrintsPerReaderText, setMaxPrintsPerReaderText] =
    React.useState("");
  const [maxPrintsPerDocumentText, setMaxPrintsPerDocumentText] =
    React.useState("");
  const [originalRecipientPrintData, setOriginalRecipientPrintData] = useState([]);
  const [originalPrintEnabledType, setOriginalPrintEnabledType] = useState("");
  const [printEnabledType, setPrintEnabledType] = useState("");
  const [allRecipientPrintData, setAllRecipientPrintData] = useState([]);
  const [showRecipientPrintPopup, setShowRecipientPrintPopup] = useState(false);
  const [recipientPrintSearch, setRecipientPrintSearch] = useState("");
  const [alertMsg, setAlertMsg] = useState("");
  const [alertType, setAlertType] = useState("");
  React.useEffect(() => {
    setMaxPrintsPerReaderText(maxPrintsPerReader);
    setMaxPrintsPerDocumentText(maxPrintsPerDocument);
  }, [modalForControlStatus]);

  React.useEffect(() => {
    if (constSecurityLevelText === "Track Views") {
      setMaxPrintsPerReaderText("");
    }
  }, [constSecurityLevelText]);

  if (!modalForControlStatus) return null;

  function maxPrintsPerReaderHandler(e) {
    let textValue = e.target.value;
    textValue = textValue.replace(/[^0-9]+/g, "");
    if (textValue == "") {
      setMaxPrintsPerReaderText(textValue);
    } else if (parseInt(textValue) >= 1 && textValue.length <= 4) {
      setMaxPrintsPerReaderText(parseInt(textValue));
    }
  }

  function maxPrintsPerDocumentHandler(e) {
    let textValue = e.target.value;
    textValue = textValue.replace(/[^0-9]+/g, "");
    if (textValue == "") {
      setMaxPrintsPerDocumentText(textValue);
    } else if (parseInt(textValue) >= 1 && textValue.length <= 4) {
      setMaxPrintsPerDocumentText(parseInt(textValue));
    }
  }

  const handleRecipientPrintEdit = () => {
    const readers = JSON.parse(JSON.stringify(currentDocument?.documentOptions?.recipients || []));
    readers.forEach(reader => {
      const existing = recipientPrintData.find(r => r.id === reader.id);
      if (existing) {
        reader.canPrint = existing.canPrint;
        reader.maxPrintsPerReader = existing.maxPrintsPerReader;
      }
    });
    setOriginalRecipientPrintData(JSON.parse(JSON.stringify(readers)));
    setOriginalPrintEnabledType(printEnabledType);
    setRecipientPrintData(readers);
    setAllRecipientPrintData(readers);
    setShowRecipientPrintPopup(true);
    setPrintEnabledType((currentDocument?.documentOptions?.isPrintEnabledForEveryone && (originalPrintEnabledType === "everyone" || originalPrintEnabledType === "")) ? "everyone" : "selectedUsers");
  };

  const saveRecipientPrintSettings = () => {
    setRecipientPrintSearch("");
    const invalidRecipient = recipientPrintData.find((recipient) => {
      if (!recipient.canPrint) { recipient.maxPrintsPerReader = ""; }
      return (maxPrintsPerDocumentText !== 0 && maxPrintsPerDocumentText !== "" && recipient.maxPrintsPerReader > maxPrintsPerDocumentText);
    });
    if (invalidRecipient) {
      setAlertMsg(selectedLanguage.LstLanguageCodes.UI_Printsperreadercannotexceedprintspersdocument);
      setAlertType("warning");
      return;
    }
    const updatedRecipients = recipientPrintData.map(reader => ({
      ...reader,
      canPrint: printEnabledType === "everyone" ? true : reader.canPrint,
      maxPrintsPerReader: (reader.canPrint) ? reader.maxPrintsPerReader : null
    }));
    onSaveRecipientPrintSettings({ recipients: updatedRecipients, printEnabledType });
    setOriginalRecipientPrintData(JSON.parse(JSON.stringify(updatedRecipients)));
    setOriginalPrintEnabledType(printEnabledType);
    setShowRecipientPrintPopup(false);
  };

  const handleRecipientPrintSearch = () => {
    const searchText = recipientPrintSearch?.trim().toLowerCase();
    if (!searchText) {
      setRecipientPrintData(allRecipientPrintData);
      return;
    }
    const filteredReaders = allRecipientPrintData.filter((reader) => {
      const email = (reader.email || "").toLowerCase();
      const firstName = (reader.firstName || "").toLowerCase();
      const lastName = (reader.lastName || "").toLowerCase();
      const fullName = `${firstName} ${lastName}`.trim();
      return (email.includes(searchText) || firstName.includes(searchText) || lastName.includes(searchText) || fullName.includes(searchText));
    });
    setRecipientPrintData(filteredReaders);
  };

  const clearRecipientPrintSearch = () => {
    setRecipientPrintSearch("");
    setRecipientPrintData(allRecipientPrintData);
  };

  const handleCheckAllPrints = (checked) => {
    const temp = [...recipientPrintData];
    temp.forEach(reader => {
      reader.canPrint = checked;
    });
    setRecipientPrintData(temp);
    setAllRecipientPrintData(JSON.parse(JSON.stringify(temp)));
  };

  const onClosePrintRestriction = () => {
    setRecipientPrintSearch("");
    let recipients = JSON.parse(JSON.stringify(originalRecipientPrintData));
    const type = originalPrintEnabledType || "everyone";
    if (canPrint && type === "everyone") {
      recipients = recipients.map(reader => ({
        ...reader,
        canPrint: true,
        maxPrintsPerReader: reader.maxPrintsPerReader || null
      }));
    }
    setRecipientPrintData(recipients);
    setPrintEnabledType(type);
    onSaveRecipientPrintSettings({ recipients, printEnabledType: type });
    setShowRecipientPrintPopup(false);
  };

  return (
    <>
      <Alert
        alertType={alertType}
        alertMsg={alertMsg}
        setAlertMsg={setAlertMsg}
        setAlertType={setAlertType}
        className="alerthist-ip"
      ></Alert>
      <div className="modalCus control-status" id="myModal">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div
              className="card-body pt-3 table-scrollbar"
              style={{
                maxHeight: "93vh",
                overflow: "auto",
                overflowX: "hidden",
                display: "block",
                paddingRight: "8px",
              }}>
              <div
                className="pb-3 justify-content-between d-flex"
                style={{ borderBottom: "2px solid #918d8d4d" }}>
                <h4
                  className="modal-heading"
                  htmlFor=""
                  style={{ margin: "0.5%" }}>
                  {selectedLanguage.LstLanguageCodes.UI_ControlStatus}
                </h4>

                <div
                  className={
                    securityLevelTextColor != ""
                      ? "d-flex align-items-center " + securityLevelTextColor
                      : "d-flex align-items-center"
                  }>
                  <span
                    className="material-icons me-3"
                    style={{
                      color: "#356fcd",
                      fontSize: "22px",
                    }}
                    id="securityLevelTooltip"
                    data-toggle="tooltip"
                    data-html="true">
                    info
                  </span>
                  <div className="securityLevelTooltip search">
                    <ReactTooltip
                      className="securityLevelTooltip"
                      style={{ opacity: 1 }}
                      anchorId="securityLevelTooltip"
                      place="bottom">
                      {
                        selectedLanguage.LstLanguageCodes
                          .UI_PleaseBewareModificationAcessControl
                      }
                    </ReactTooltip>
                  </div>
                  <select
                    style={{
                      marginRight: "0.7rem",
                      width: "auto",
                      padding: "0.65rem 2.72rem 0.75rem 0.74rem !important",
                      border: "1px solid",
                    }}
                    className={
                      securityLevelTextColor != ""
                        ? "fw-bold form-select form-control select-border rounded h-32p " +
                        securityLevelTextColor
                        : "text-danger  fw-bold form-select form-control select-border rounded h-32p"
                    }
                    title={selectedLanguage.LstLanguageCodes.UI_AccessControl}
                    onChange={(e) => handleLevelChange(e,
                      {
                        prints: canPrint,
                        maxPrintsPerReader: (maxPrintsPerReaderText == 0 || maxPrintsPerReaderText == "") ? "" : maxPrintsPerReaderText,
                        maxPrintsPerDocument: (maxPrintsPerDocumentText == 0 || maxPrintsPerDocumentText == "") ? "" : maxPrintsPerDocumentText
                      }
                    )}
                    value={constSecurityLevelText}>
                    <option
                      className="level1"
                      value={"Track Views"}>
                      {selectedLanguage.LstLanguageCodes.UI_TrackViews}
                    </option>
                    <option
                      className="level2"
                      value={
                        "Track Readers"
                      }>
                      {selectedLanguage.LstLanguageCodes.UI_TrackReaders}
                    </option>
                    <option
                      className="text-danger"
                      value={
                        "Limit Readers"
                      }>
                      {selectedLanguage.LstLanguageCodes.UI_LimitReaders}
                    </option>
                  </select>
                  {/* {constSecurityLevelText}*/}
                </div>
              </div>

              <div className="row">
                <div className="col-12 col-sm-12 col-md-12 col-lg-7 res-col pt-3 pb-3">
                  <div className="row">
                    <div className="col-sm-12 col-md-6 res-pr2 res-pr2px">
                      <div className="input-group res-datepicker custom-inputBorder">
                        <span
                          className="min-width58 input-group-text start-date"
                          style={{ height: "48px" }}>
                          {selectedLanguage.LstLanguageCodes.UI_Launches}
                        </span>
                        <div className="form-control h-50p clander-style border-Left">
                          {isDatetimeControl == "false" ? (
                            <DatePicker
                              selected={startTime}
                              onChange={(date) =>
                                handlerExpirationDaysStartTime(date, true)
                              }
                              onFocus={(e) => IntiateTime(e, 0)}
                              //  isClearable
                              id="dthstart1"
                              dateFormat={dateFormatValueOriginal}
                              className="textAlignment DateCalendarSend"
                              placeholderText={dateFormatValueLower}>
                              {/* <div style={{ color: "red" }}>Don't forget to check the weather!</div> */}
                            </DatePicker>
                          ) : (
                            <DatePicker
                              selected={startTime}
                              onChange={(date) =>
                                handlerExpirationDaysStartTime(date, true)
                              }
                              onFocus={(e) => IntiateTime(e, 0)}
                              showTimeSelect
                              timeCaption="Time"
                              id="dthstart"
                              //  isClearable
                              timeIntervals={1}
                              timeFormat="HH:mm"
                              dateFormat={dateFormatValueOriginal + " HH:mm"}
                              className="textAlignment DateCalendarSend"
                              placeholderText={
                                dateFormatValueLower + " --:--"
                              }>
                              {/* <div style={{ color: "red" }}>Don't forget to check the weather!</div> */}
                            </DatePicker>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-6  res-pr2 pl-6p">
                      <div className="input-group res-datepicker custom-inputBorder">
                        <span
                          className="min-width20 input-group-text"
                          style={{ height: "48px" }}>
                          {selectedLanguage.LstLanguageCodes.UI_Expires}
                        </span>
                        <div className="form-control h-50p clander-style border-Left">
                          {isDatetimeControl == "false" ? (
                            <DatePicker
                              selected={expiryTime}
                              onChange={(date) =>
                                handlerExpirationDaysExpiryTime(date, true)
                              }
                              onFocus={(e) => IntiateTime(e, 1)}
                              //  isClearable
                              id="dthexpiry1"
                              dateFormat={dateFormatValueOriginal}
                              className="textAlignment DateCalendarSend"
                              placeholderText={dateFormatValueLower}>
                              {/* <div style={{ color: "red" }}>Don't forget to check the weather!</div> */}
                            </DatePicker>
                          ) : (
                            <DatePicker
                              selected={expiryTime}
                              onChange={(date) =>
                                handlerExpirationDaysExpiryTime(date, true)
                              }
                              onFocus={(e) => IntiateTime(e, 1)}
                              showTimeSelect
                              timeCaption="Time"
                              timeIntervals={1}
                              timeFormat="HH:mm"
                              id="dthexpiry"
                              dateFormat={dateFormatValueOriginal + " HH:mm"}
                              className="textAlignment DateCalendarSend"
                              placeholderText={
                                dateFormatValueLower + " --:--"
                              }
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className={
                      "input-group field mt-3 pl-6p res-pr2 user_register pl-0p custom-inputBorder " +
                      constSecurityLevelClass
                    }>
                    <span className="input-group-text res-width h-3rem min-width28 res-min-width">
                      {selectedLanguage.LstLanguageCodes.UI_RestrictToDomains}{" "}
                    </span>
                    <input
                      type="text"
                      className="form-control h-50p border-Left"
                      placeholder={
                        selectedLanguage.LstLanguageCodes.UI_ExampleORGExample
                      }
                      id="txtRestrictDomains"
                      onChange={(e) => setDomains(e.target.value.replace(/\s/g, ""))}
                      value={domains}
                      tabIndex="30"
                    />
                  </div>
                  <div className="row">
                    <div className="col-12 col-sm-12 col-md-6 res-pr2 res-pr2px">
                      <div
                        className={
                          "input-group field res-pr2 user_register res-nowwrap control-height custom-inputBorder " +
                          constSecurityLevelClass
                        }>
                        <span
                          className="input-group-text res-width toolltipModified h-50p min-width58 truncated-label-container w-input-label"
                          title={selectedLanguage.LstLanguageCodes.UI_MaxReadsperReader}
                        >
                          <span className="truncated-text-inner">
                            {selectedLanguage.LstLanguageCodes.UI_MaxReadsperReader}
                          </span>
                        </span>
                        <input
                          type="text"
                          placeholder={
                            selectedLanguage.LstLanguageCodes.UI_Unlimited
                          }
                          className=" control form-control h-50p border-Left"
                          id="maxReads"
                          onChange={(e) => {
                            const val = e.target.value.replace(/[^0-9]/g, "");
                            if (val === "" || val === "0") {
                              ChangeMaxReadsTexts("");
                              return;
                            }
                            const parsed = parseInt(val);
                            if (parsed > 100000) return;
                            ChangeMaxReadsTexts(String(parsed));
                          }}
                          value={maxReadsText}
                          tabIndex="35"
                        />
                      </div>
                    </div>
                    <div className="col-12 col-sm-12 col-md-6 res-pr2 pl-6p">
                      <div className="input-group field custom-inputBorder res-nowwrap control-height ">
                        <span
                          title={
                            selectedLanguage.LstLanguageCodes
                              .UI_MaxviewsPerDocument
                          }
                          className={`input-group-text toolltipModified res-width min-width20 res-minWidth${localStorage.getItem("language") !== "en-us" ? " truncate ellipsis-text" : ""}`}>
                          {
                            selectedLanguage.LstLanguageCodes
                              .UI_MaxviewsPerDocument
                          }{" "}
                        </span>
                        <input
                          type="text"
                          placeholder={
                            selectedLanguage.LstLanguageCodes.UI_Unlimited
                          }
                          className=" control form-control h-50p border-Left"
                          id="maxViewsPerDocument"
                          onChange={(e) =>
                            ChangeMaxViewsPerDocumentTexts(e.target.value)
                          }
                          value={maxViewsPerDocumentText}
                          title={
                            maxViewsPerDocumentText === ""
                              ? selectedLanguage.LstLanguageCodes.UI_Unlimited
                              : ""
                          }
                          tabIndex="36"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="input-group field mt-3 res-column custom-inputBorder">
                    <div
                      className="checkbox control usercheck min-width48 sendCreate-bg text-wrap"
                      style={{ padding: "0.29rem 0.8rem" }}>
                      <label className="ps-0 control checkbox-color">
                        {
                          selectedLanguage.LstLanguageCodes
                            .UI_AllowResponsesTo
                        }
                        :
                      </label>
                    </div>
                    <input
                      className="form-control h-50p border-Left"
                      name="username"
                      type="email"
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value.includes(" ") || value.includes(",") || value.includes(";")) return;
                        setResponseAddress(value);
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === "Tab") {
                          e.preventDefault();
                        }
                      }}
                      onBlur={(e) => {
                        const EmailRegex = /^(?=.{1,254}$)[a-zA-Z0-9._%+\-]{1,64}@(?:[a-zA-Z0-9](?:[a-zA-Z0-9\-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/;
                        const value = e.target.value.trim();
                        if (value && !EmailRegex.test(value)) {
                          setResponseAddress(value);
                        }
                      }}
                      value={responseAddress}
                      disabled={!constAllowResFlag}
                      tabIndex="6"
                    />
                  </div>
                  {/* Send Verification code */}
                  <div className="input-group field mt-3 res-column reactCustome-select custom-inputBorder manage-bg">
                    <div
                      className="checkbox control usercheck min-width48 text-wrap"
                      style={{ padding: "0.29rem 0.8rem" }}>
                      <label className="ps-0 control checkbox-color">
                        {
                          selectedLanguage.LstLanguageCodes
                            .UI_SendVerificationCode
                        }
                        :
                      </label>
                    </div>
                    <SelectCountry
                      classNamePrefix="select"
                      id="select-method"
                      isDisabled={sendVerificationCodeDisable}
                      onChange={handleSelectionChange}
                      value={selectedOptions}
                      isMulti
                      name="methods"
                      options={filteredOptions}
                      isSearchable={false}
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          width: "100%",
                          height: "47px",
                          minHeight: "30px",
                          borderRadius: "0",
                          borderLeft: "1px",
                          // boxShadow: '1px 5px 5px -4px rgb(195 198 203)',
                          cursor: "pointer",
                          borderLeft: "1px solid #adadad",
                        }),
                        menu: (provided) => ({
                          ...provided,
                          width: "23.7rem",
                        }),
                        option: (provided) => ({
                          ...provided,
                          padding: "7px",
                          fontSize: "16px",
                          paddingRight: "5px",
                        }),
                        multiValue: (provided) => ({
                          ...provided,
                          fontSize: "14px", // Font size for selected values
                          paddingRight: "5px",
                        }),
                        multiValueLabel: (provided) => ({
                          ...provided,
                          fontSize: "14px", // Font size for labels in selected values
                          paddingRight: "5px",
                        }),
                      }}
                      placeholder="Select a method"
                      components={{
                        ClearIndicator: (props) => (
                          <components {...props} />
                        ),
                        MultiValueRemove, // Use custom remove component
                      }}
                      noOptionsMessage={() => null}
                    />
                  </div>
                  <div className="col-sm-12 mt-2 mb-2 res-pr2 ps-1">
                    <div
                      className="d-flex align-items-center"
                      style={{
                        // border: "1px solid #ced4da",
                        borderRadius: "0.25rem",
                      }}>
                      <div
                        className="checkbox mt-0 mb-0  d-flex align-items-center"
                        style={{
                          border: "1px solid #ced4da",
                          padding: "11px",
                          whiteSpace: "nowrap",
                        }}>
                        <label className="ps-0 mb-0">
                          <input
                            type="checkbox"
                            onChange={(e) => {
                              setPrint(e.target.checked)
                              if (e.target.checked === true) {
                                if (constSecurityLevelText === "Track Views") return; handleRecipientPrintEdit();
                              }
                              if (e.target.checked == false) {
                                setMaxPrintsPerReaderText("");
                                setMaxPrintsPerDocumentText("");
                              }
                            }}
                            value={canPrint}
                            checked={canPrint}
                          />
                          <span className="cr" tabIndex="42">
                            <i className="cr-icon material-icons">check</i>
                          </span>
                          <span
                            className={`toolltipModified  top`}
                          >
                            {selectedLanguage.LstLanguageCodes.UI_CanPrint}
                          </span>
                        </label>
                        {canPrint && (<span className={"material-icons top3"}
                          style={{
                            marginLeft: "4pt", fontWeight: 500,
                            cursor: (constSecurityLevelText === "Track Views") ? "not-allowed" : "pointer", fontSize: "20px", marginBottom: "7px",
                            opacity: (constSecurityLevelText === "Track Views") ? 0.5 : 1
                          }}
                          onClick={() => { if (constSecurityLevelText === "Track Views") return; handleRecipientPrintEdit(); }}
                        > edit
                        </span>)}
                      </div>

                      <div className="d-flex flex-grow-1 align-items-center">
                        <div
                          className="input-group field mt-0 res-nowwrap control-height custom-inputBorder me-3"
                          style={{ flex: 1, minWidth: "150px" }}>
                          <span
                            className="input-group-text res-width toolltipModified h-50p min-width66 truncated-label-container w-input-label"
                            title={selectedLanguage.LstLanguageCodes.UI_MaxPrintsPerReader}
                          >
                            <span className="truncated-text-inner">
                              {selectedLanguage.LstLanguageCodes.UI_MaxPrintsPerReader}
                            </span>
                          </span>
                          <input
                            type="text"
                            placeholder={
                              selectedLanguage.LstLanguageCodes.UI_Unlimited
                            }
                            className="control form-control h-47p border-Left"
                            value={(maxPrintsPerReaderText == 0 || maxPrintsPerReaderText == "" || constSecurityLevelText === "Track Views") ? "" : maxPrintsPerReaderText}
                            onChange={(e) => maxPrintsPerReaderHandler(e)}
                            disabled={
                              constSecurityLevelText === "Track Views" ||
                              !canPrint
                            }
                          />
                        </div>

                        <div
                          className="input-group field res-nowwrap control-height custom-inputBorder"
                          style={{ flex: 1, minWidth: "150px" }}>
                          <span className={`input-group-text res-width forced-label-style toolltipModified${localStorage.getItem("language") !== "en-us" ? " truncate ellipsis-text" : ""}`} style={{ minWidth: "175px" }}
                            title={selectedLanguage.LstLanguageCodes.UI_MaxPrintsPerDocument}>
                            {selectedLanguage.LstLanguageCodes.UI_MaxPrintsPerDocument}
                          </span>
                          <input
                            type="text"
                            placeholder={
                              selectedLanguage.LstLanguageCodes.UI_Unlimited
                            }
                            className="control form-control h-47p border-Left"
                            value={maxPrintsPerDocumentText == 0 || maxPrintsPerDocumentText == "" ? "" : maxPrintsPerDocumentText}
                            onChange={(e) => maxPrintsPerDocumentHandler(e)}
                            disabled={!canPrint}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className=" row mt-3 align-items-center res-flex">
                    <div
                      className={
                        `checkbox col-12 col-sm-12 col-md-5 user_register  +
                      ${constSecurityLevelClass} ${AppContext.ContentSecurity ? "disable_sectionChailed" : ""}`
                      }
                      id="chkIdentifyLeakersDiv">
                      <label className="ps-1 pl-0p checkbox-color">
                        <input
                          type="checkbox"
                          id="chkIdentifyLeakers"
                          onChange={(e) => setSteganography(e.target.checked)}
                          value={steganography}
                          checked={steganography}
                        />
                        <span className="cr" tabIndex="40">
                          <i className="cr-icon material-icons">check</i>
                        </span>
                        {selectedLanguage.LstLanguageCodes.UI_IDLeakers}
                      </label>
                    </div>
                    {/* <div className="checkbox col-12 col-sm-12 col-md-5">
                    <label className="ps-0 checkbox-color">
                      <input
                        type="checkbox"
                        onChange={(e) => setPrint(e.target.checked)}
                        value={canPrint}
                        checked={canPrint}
                      />
                      <span className="cr" tabIndex="42">
                        <i className="cr-icon material-icons">check</i>
                      </span>
                      {selectedLanguage.LstLanguageCodes.UI_CanPrint}
                    </label>
                  </div> */}
                    <div
                      className={`checkbox col-12 col-sm-12 col-md-5 ${(eDisclosure == false) ? "disable_sectionChailed" : ""
                        }`}>
                      <label className="ps-0 checkbox-color">
                        <input
                          className="form-check-input notLevelOne "
                          type="checkbox"
                          id="EDisclosure"
                          ref={EDisclosureResRef}
                          onChange={handleEDisclosure}
                          // onChange={(e) =>
                          //   setEDisclosure(e.target.checked)
                          // }
                          value={isEDisclosureChecked}
                          checked={isEDisclosureChecked}
                        />
                        <span className="cr" tabIndex="12">
                          <i className="cr-icon material-icons">check</i>
                        </span>
                        {
                          selectedLanguage.LstLanguageCodes
                            .UI_EDisclosure
                        }{" "}
                      </label>
                    </div>
                  </div>
                  <div
                    className={
                      "row align-items-center res-flex user_register res-mt0 " +
                      constSecurityLevelClass
                    }>
                    <div className={"checkbox col-12 col-sm-12 col-md-5 "}>
                      <label className="ps-1 pl-0p checkbox-color">
                        <input
                          className="form-check-input notLevelOne "
                          type="checkbox"
                          id="voting"
                          onChange={(e) => handleSetVoting(e.target.checked)}
                          value={voting}
                          checked={voting}
                        />
                        <span className="cr" tabIndex="14">
                          <i className="cr-icon material-icons">check</i>
                        </span>
                        {selectedLanguage.LstLanguageCodes.UI_Voting}
                      </label>
                    </div>
                    <div
                      className={
                        voting == true
                          ? "checkbox col-12 col-sm-12 col-md-6 disable_sectionChailedClass "
                          : "checkbox col-12 col-sm-12 col-md-6 disable_sectionChailedClass "
                      }>
                      <label className="ps-0 checkbox-color">
                        {voteSharing && (
                          <input
                            className="form-check-input notLevelOne "
                            type="checkbox"
                            id="voteShare"
                            onChange={(e) => setVoteSharing(e.target.checked)}
                            value={voteSharing}
                            checked={voteSharing}
                          />
                        )}
                        {!voteSharing && (
                          <input
                            className="form-check-input notLevelOne "
                            type="checkbox"
                            id="voteShare"
                            onChange={(e) => setVoteSharing(e.target.checked)}
                            value={voteSharing}
                            checked={voteSharing}
                          />
                        )}
                        <span className="cr" tabIndex="15">
                          <i className="cr-icon material-icons">check</i>
                        </span>
                        {selectedLanguage.LstLanguageCodes.UI_ShareVotes}
                      </label>
                    </div>
                  </div>
                  <div
                    className={
                      " row align-items-center res-flex  "
                    }>
                    <div
                      className={
                        "checkbox col-12 col-sm-12 col-md-5 user_register" +
                        constSecurityLevelClass
                      }>
                      <label className="ps-1 pl-0p checkbox-color">
                        <input
                          className="form-check-input notLevelOne "
                          type="checkbox"
                          id="distribution"
                          onChange={(e) =>
                            setDistributionList(e.target.checked)
                          }
                          value={distributionList}
                          checked={distributionList}
                        />
                        <span className="cr" tabIndex="12">
                          <i className="cr-icon material-icons">check</i>
                        </span>
                        {
                          selectedLanguage.LstLanguageCodes
                            .UI_DisplayDistributionlist
                        }{" "}
                      </label>
                    </div>
                    <div
                      className={`checkbox col-sm-12 col-md-6 ${(isPageLevelRestrictionSetting == 'false' && !isPageLevelData) ? "disable_sectionChailed" : ""
                        }`}>
                      <label className="ps-0 checkbox-color">
                        <input
                          className="form-check-input notLevelOne "
                          type="checkbox"
                          id="pagelevelrestriction"
                          ref={pageLevelResRef}
                          value={isPageLevelRestrictionChecked}
                          checked={isPageLevelRestrictionChecked}
                          onChange={handlePageLevelRestrictionCheck}
                        />
                        <span className="cr" tabIndex="14">
                          <i className="cr-icon material-icons">check</i>
                        </span>
                        <span
                        //className={`toolltipModified ${position}`}
                        //onMouseEnter={handleMouseEnter}
                        >
                          {
                            selectedLanguage.LstLanguageCodes
                              .UI_Pagelevelrestrictions
                          }
                        </span>
                      </label>
                      {isPageLevelRestrictionChecked && (
                        <span
                          className={"material-icons top3"}
                          title={""}
                          style={{
                            marginLeft: "4pt",
                            fontWeight: 500,
                            cursor: "pointer",
                            fontSize: "20px",
                          }}
                          onClick={(e) =>
                            handlePageLevelRestrictionEdit(true)
                          }>
                          edit
                        </span>
                      )}
                    </div>
                  </div>
                  {/* <div
                  className={
                    " row align-items-center res-flex  "
                  }>
                  

                </div> */}
                  <div
                    className={
                      " row align-items-center res-flex user_register " +
                      constSecurityLevelClass
                    }>
                    <div
                      className={"checkbox col-12 col-sm-12 col-md-5 "}></div>
                  </div>
                </div>
                <div className="col-12 col-sm-12 col-md-12 col-lg-5 res-col border-Left pt-3">
                  <div className=" p-0 ">
                    <div className="card-body ps-0 pe-1">
                      <div className="p-3 pb-0 pt-0 manage-map">
                        <div className=" mt-n1">
                          <div className="d-flex align-items-center justify-content-between">
                            <h6 className="font-1rem">
                              {
                                selectedLanguage.LstLanguageCodes
                                  .UI_BannedRegions
                              }
                            </h6>
                          </div>
                          <div className="mt-40 historymap pt-3">
                            <WorldContinents
                              regions={constContinents}
                              tabValue="history"></WorldContinents>
                          </div>
                        </div>
                        <MultipleIps
                          id="multipleips"
                          type="text"
                          display="none"
                          constmultipleips={constmultipleips}
                          onChange={(constmultipleips) => {
                            setConstMultipleIps({ ...constmultipleips });
                          }}></MultipleIps>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="d-flex justify-content-center pt-3"
                style={{ borderTop: "2px solid #918d8d4d" }}>
                <button
                  type="button"
                  className="btn btn-danger px-4 me-1"
                  data-bs-dismiss="modal"
                  onClick={(e) => handlerModelCancelForControlStatus()}>
                  {selectedLanguage.LstLanguageCodes.UI_Cancel}
                </button>
                <button
                  type="button"
                  className="btn btn-primary px-2rem ms-3"
                  onClick={() => handlerModelConfirmForControlStatus(false, null,
                    {
                      prints: canPrint,
                      maxPrintsPerReader: (maxPrintsPerReaderText == 0 || maxPrintsPerReaderText == "") ? "" : maxPrintsPerReaderText,
                      maxPrintsPerDocument: (maxPrintsPerDocumentText == 0 || maxPrintsPerDocumentText == "") ? "" : maxPrintsPerDocumentText
                    })}>
                  {selectedLanguage.LstLanguageCodes.UI_Save}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showRecipientPrintPopup && (
        <div className="modal pagemodal d-block">
          <div className="modal-dialog modal-dialog-centered modal-customelg" style={{ width: "70vw", maxWidth: "62.5rem" }}>
            <div className="modal-content card-body pt-0">
              <div className="modal-header pb-1 ps-1">
                <h4 className="d-flex align-items-center text-danger fw-bold">
                  {selectedLanguage.LstLanguageCodes.UI_PrintRestrictions}
                </h4>
                <span className="material-icons" style={{ cursor: "pointer", fontSize: "24px", marginLeft: "auto" }}
                  onClick={() => onClosePrintRestriction()}
                >close
                </span>
              </div>
              <div className="row d-flex align-items-center flex-wrap justify-content-between my-3 pt-2 mx-1">
                <div className=" d-flex " style={{ marginTop: "-10px" }}>
                  <div style={{ position: "relative", right: "1.25rem", display: "flex", alignItems: "center" }}>
                    <span className="radio me-4 cursor-unlocked">
                      <input id="printEnabledEveryone" name="PrintEnabled" type="radio" value="everyone"
                        checked={printEnabledType === "everyone"}
                        onChange={() => { setPrintEnabledType("everyone"); }}
                      />
                      <label
                        htmlFor="printEnabledEveryone"
                        className="radio-label font-w500 control res-w res-left12"
                        style={{ fontSize: "14px !important" }}
                      > {selectedLanguage.LstLanguageCodes.UI_EnabledForEveryone}
                      </label>
                    </span>
                    <span className="radio me-4 cursor-unlocked">
                      <input id="printEnabledSelected" name="PrintEnabled" type="radio" value="selectedUsers"
                        checked={printEnabledType === "selectedUsers"}
                        onChange={() => { setPrintEnabledType("selectedUsers"); }}
                      />
                      <label
                        htmlFor="printEnabledSelected"
                        className="radio-label font-w500 control res-w res-left12"
                        style={{ fontSize: "14px !important" }}
                      > {selectedLanguage.LstLanguageCodes.UI_EnabledForSelectedUsers}
                      </label>
                    </span>
                  </div>
                  <div style={{ display: "flex", position: "relative", left: "5rem" }}>
                    <input className="custom-inputBorder" type="text" style={{ width: "16rem" }} autoComplete="none" placeholder={selectedLanguage.LstLanguageCodes.UI_NameOrEmailSearch}
                      value={recipientPrintSearch}
                      onChange={(e) => setRecipientPrintSearch(e.target.value)}
                      onKeyDown={(e) => { if (e.key === "Enter") { handleRecipientPrintSearch(); } }}
                    />
                    <div style={{ display: "flex" }}>
                      <span className="material-icons searchHistory" style={{ cursor: "pointer" }}
                        onClick={handleRecipientPrintSearch}
                      > search
                      </span>
                      <span className="material-icons cancelHistory" style={{ cursor: "pointer" }} onClick={clearRecipientPrintSearch}>
                        block
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div className="card-body-new pt-0" style={{ height: "350px", overflow: "hidden auto", }}>
                  <div className="table-responsive res-card">
                    <table className="fold-table table tablelayout" cellPadding="0" cellSpacing="0">
                      <thead className="bg-lightblue">
                        <tr>
                          <th className="w-35p">
                            <span>{selectedLanguage.LstLanguageCodes.UI_Email}</span>
                          </th>
                          <th className="w-25p">
                            <span>{selectedLanguage.LstLanguageCodes.UI_Name}</span>
                          </th>
                          <th className="w-15p text-center">
                            <div className="checkbox d-flex align-items-center justify-content-center" style={{ position: "relative", left: "1rem" }}>
                              <label className="p-0 mb-0">
                                <input type="checkbox" disabled={printEnabledType === "everyone"}
                                  checked={recipientPrintData.length > 0 && (printEnabledType === "everyone" || recipientPrintData.every((reader) => reader.canPrint === true))} onChange={(e) => handleCheckAllPrints(e.target.checked)}
                                />
                                <span className="cr">
                                  <i className="cr-icon material-icons">
                                    check
                                  </i>
                                </span>
                                <span style={{ marginLeft: "8px" }}>
                                  {selectedLanguage.LstLanguageCodes.UI_LabelPrint}
                                </span>
                              </label>
                            </div>
                          </th>
                          <th className="w-25p text-center">
                            <span>{selectedLanguage.LstLanguageCodes.UI_MaxAllowedPrints}</span>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {recipientPrintData.length === 0 ? (
                          <tr>
                            <td colSpan="4" className="text-center py-4">{selectedLanguage.LstLanguageCodes.UI_NoReadersFound}</td>
                          </tr>
                        ) : (
                          recipientPrintData.map((reader, index) => (
                            <tr key={index} className="borderrow">
                              <td className="text-start" title={reader.email} style={{ borderLeft: "0.1rem solid rgba(231, 229, 229, 0.44)", }}>
                                <div className="d-flex flex-wrap textwrap">
                                  {reader.email}
                                </div>
                              </td>
                              <td className="text-start" title={`${reader.firstName || ""} ${reader.lastName || ""}`} style={{ borderLeft: "0.1rem solid rgba(231, 229, 229, 0.44)", }}>
                                <span className="Wordbreak">
                                  {(reader.firstName || "") + " " + (reader.lastName || "")}
                                </span>
                              </td>
                              <td className="text-center" style={{ borderLeft: "0.1rem solid rgba(231, 229, 229, 0.44)", }}>
                                <div className="checkbox mt-n5p marginTop8">
                                  <label className="p-0 mb-0">
                                    <input type="checkbox" disabled={printEnabledType === "everyone"}
                                      checked={printEnabledType === "everyone" ? true : reader.canPrint === true}
                                      onChange={(e) => {
                                        const temp = [...recipientPrintData];
                                        temp[index].canPrint = e.target.checked;
                                        setRecipientPrintData(temp);
                                        setAllRecipientPrintData(JSON.parse(JSON.stringify(temp)));
                                      }}
                                    />
                                    <span className="cr">
                                      <i className="cr-icon material-icons">
                                        check
                                      </i>
                                    </span>
                                  </label>
                                </div>
                              </td>
                              <td style={{ borderLeft: "0.1rem solid rgba(231, 229, 229, 0.44)", }}>
                                <input type="text" placeholder={selectedLanguage.LstLanguageCodes.UI_EnterMaxAllowedPrints}
                                  className="form-control custom-inputBorder" disabled={printEnabledType !== "everyone" && !reader.canPrint}
                                  value={(printEnabledType !== "everyone" && !reader.canPrint) ? "" : (reader.maxPrintsPerReader !== undefined && reader.maxPrintsPerReader !== null && reader.maxPrintsPerReader !== 0 ? reader.maxPrintsPerReader : "")}
                                  onChange={(e) => {
                                    const temp = [...recipientPrintData];
                                    const printValue = e.target.value.replace(/[^0-9]+/g, "");
                                    const numberValue = parseInt(printValue, 10);
                                    if (printValue === "") {
                                      temp[index].maxPrintsPerReader = "";
                                    }
                                    else if (printValue.length <= 4 && numberValue >= 1 && numberValue <= 9999) {
                                      temp[index].maxPrintsPerReader = numberValue;
                                    }
                                    setRecipientPrintData(temp);
                                    setAllRecipientPrintData(JSON.parse(JSON.stringify(temp)));
                                  }}
                                />
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              {recipientPrintData.length > 0 && (<div className="d-flex align-items-center justify-content-end mb-1 mt-3" style={{ marginTop: "8px" }}>
                <button type="button" className="btn btn-danger px-4 me-1" onClick={() => onClosePrintRestriction()}>
                  {selectedLanguage.LstLanguageCodes.UI_Cancel}
                </button>
                <button type="button" className="btn btn-primary px-4 ms-3" onClick={saveRecipientPrintSettings}>
                  {selectedLanguage.LstLanguageCodes.UI_Confirm}
                </button>
              </div>)}
            </div>
          </div>
        </div >
      )}
    </>
  );
};

export default ControlStatusModal;
